import React from "react";

import { Button, ButtonProps, useTracking } from "@origin-digital/ods-core";

export type TrackedButtonProps = Omit<ButtonProps, "onClickCapture"> & {
  trackingLabel: string;
};

export const TrackedButton = ({
  trackingLabel,
  "data-id": dataId = "button",
  ...props
}: TrackedButtonProps) => {
  const { onClickCapture } = useTracking({
    children: trackingLabel,
    "data-id": dataId,
    type: "Button",
  });

  return <Button {...props} data-id={dataId} onClickCapture={onClickCapture} />;
};
